import { IContent } from '@_entities/content';

import { useUILayerStore } from '@_shared/stores/useUILayerStore';

import { ContentOptionsModal } from '../../ui';

export function useContentOptionsModal() {
	const { pushLayer } = useUILayerStore();

	const openContentOptionsModal = (
		content: IContent,
		isContentListPage: boolean,
		isFolderDetailPage: boolean,
		contentTitle?: string,
	) => {
		pushLayer(
			'modal',
			<ContentOptionsModal
				content={content}
				isContentListPage={isContentListPage}
				contentTitle={contentTitle}
				isFolderDetailPage={isFolderDetailPage}
			/>,
		);
	};

	return {
		openContentOptionsModal,
	};
}
